/* globals Class, lp, jui */
var _      = require('lodash');
var jQuery = require('jquery');

module.exports = Class.create(
  lp.editor.BuilderModal,
  lp.ModuleComponent,
  {
    type:'lp-stylesheet',

    initialize: function($super){
      this.controls = {};
      this.currentStylesheets = [];
      this.newStylesheets = [];
      this.selectedStylesheet = null;
      this.undoGroupStarted = false;

      $super({
        actions: [{
          id: 'done',
          label: 'Done',
          class: 'save-code-button action',
          action: this.done.bind(this)
        },
        {
          id: 'cancel',
          class: 'push-left',
          label: 'Discard',
          action: this.close.bind(this)
        }],
        attributes: {
          className: 'modal-panel stylesheets-panel'
        },
        layoutRules: {
          method: lp.editor.BuilderModal.fitToViewport,
          options: {
            padding: 12,
            size:{width:1000, height:600}
          }
        },
        closeX: true
      });
    },

    _updateHeaderTitle: function() {
      var usedAsText = window.editor.page.getUsedAsText();
      var headerTitleText = 'Manage Stylesheets on ' + usedAsText;

      if (window.editor.page.usedAs() === 'main') {
        headerTitleText = 'Manage Stylesheets';
      }

      this.setTitle(headerTitleText);
    },

    installUI: function( $super ) {
      $super();
      var updateView = this.updateView.bind(this);

      this._updateHeaderTitle();

      var manager = this.contentPanel.insert(new jui.Component({
        attributes: {
          className: 'stylesheets-manager'
        }
      }));

      var leftContainer = jQuery('<div class="modal-left-panel">');
      manager.insert(leftContainer[0]);

      this.toolBar = new jui.Component({attributes:{className:'toolbar'}});
      leftContainer.append(this.toolBar.e);

      this.controls.addStylesheet = this.toolBar.insert(new jui.Button({
        attributes: {
          class: 'button large green',
        },
        action:this.addStylesheet.bind(this)})
      ).update('Add Stylesheet');

      this.list = new jui.Component({attributes:{className:'list'}});

      var $stylesheetsCollection = jQuery('<div class="stylesheets-collection">').append(this.list.e);

      leftContainer.append($stylesheetsCollection[0]);

      this.details = manager.insert(new jui.Component({attributes:{className:'details modal-right-panel'}}));
      this.controls.stylesheetName = this.details.insert(new jui.FormTextInput({
        label:'Stylesheet Name',
        onkeyup:updateView
      }));

      this.controls.codeEditor = this.details.insert(new jui.CodeEditor({
        label:'Paste or type stylesheets below. &lt;style&gt; or &lt;link&gt; tags must be included'
        }));

      this.warn = this.actionBar.insert(new Element('div', {
        className: 'warn'
      }).update('You must enter a valid stylesheet'));
      this.warn.hide();
    },

    updateList: function() {
      this.selectedStylesheet = null;
      this.currentStylesheets = window.editor.page.getElementsByType('lp-stylesheet').clone();
      this.list.clear();
      var ul = this.list.insert(new Element('ul'));
      var stylesheets = this.currentStylesheets.concat(this.newStylesheets);

      if (stylesheets.length === 0) {
        this.addStylesheet();
        return;
      }

      stylesheets.each(function(s){
        var styleTitle = s.model.get('name');

        var $removeButton = jQuery('<a class="remove-button" href="#">✕</a>');
        $removeButton = jQuery('<a class="remove-button svg-ico-delete"></a>');

        $removeButton.on('click', function(){
          this.removeStylesheet(s);
          this.updateList();
        }.bind(this));

        var li = new Element('li',{id:'item-'+s.id, title: styleTitle}).insert(new Element('div', {className: 'script-label'}).insert(
          new Element('a',{'href':'#'}).update(styleTitle.truncate(25))
          .observe('click',this.listItemClicked.bind(this, s))));

        li.insert($removeButton[0]);

        ul.insert(li);
      }, this);

      this.selectStylesheet(stylesheets.last());
    },

    listItemClicked: function(stylesheet) {
      if (stylesheet === this.selectedStylesheet){ return; }
      var originalScrollPosition = this.list.e.down('ul').scrollTop;
      this.updateSelectedStylesheet();
      if (!this.validateStylesheet(this.selectedStylesheet)) {
        this.removeStylesheet(this.selectedStylesheet);
      }
      this.updateList();
      this.selectStylesheet(stylesheet);
      this.list.e.down('ul').scrollTop = originalScrollPosition;
    },

    selectStylesheet: function(stylesheet) {
      if (this.selectedStylesheet !== null){
        this.updateSelectedStylesheet();
        this.list.e.down('li#item-'+this.selectedStylesheet.id).removeClassName('active');
      }

      this.controls.stylesheetName.setValue(stylesheet.model.get('name'));
      this.controls.codeEditor.setValue( stylesheet.model.get( 'content.html' ) );
      this.controls.codeEditor.focus();
      this.list.e.down('li#item-'+stylesheet.id).addClassName('active');

      this.selectedStylesheet = stylesheet;

      var editor = this.controls.codeEditor,
          valid = stylesheet.model.exists('content.valid') ? stylesheet.model.get('content.valid') : true;
      editor.showHTMLWarningIfInvalid(this, this.closeIfValid, valid);
    },

    addStylesheet: function() {
      this.updateSelectedStylesheet();

      if (this.selectedStylesheet !== null && !this.validateStylesheet(this.selectedStylesheet)) {
        return;
      }

      var module = this.getModule();

      var newStylesheet = module.buildPageElement(window.editor.page, {
        name: window.editor.page.generateDefaultElementName(module.type, module.defaultName),
        containerId:null,
        placement:'body:after',
        content:{
          type:null,
          html:''
        }
      });

      this.newStylesheets.push(newStylesheet);
      this.selectedStylesheet = null;
      this.updateList();
      this.list.e.down('ul').scrollTop = this.list.e.down('ul').scrollHeight;
    },

    removeStylesheet: function(stylesheet) {
      window.editor.page.undoManager.startGroup();
      stylesheet.removeFromPage();
      window.editor.page.undoManager.endGroup();
    },

    removeSelectedStylesheet: function() {
      if (this.selectedStylesheet === null) {
        return;
      }

      if (this.currentStylesheets.indexOf(this.selectedStylesheet) > -1) {
        this.removeStylesheet(this.selectedStylesheet);
      } else {
        this.newStylesheets = this.newStylesheets.without(this.selectedStylesheet);
      }

      this.selectedStylesheet = null;
      this.updateList();
    },

    validateStylesheet: function(stylesheet) {
      return stylesheet !== null && stylesheet.model.get('content.html') !== '';
    },

    updateSelectedStylesheet: function() {
      var s = this.selectedStylesheet;

      if (s === null) {
        return;
      }

      var isNew = this.currentStylesheets.indexOf(s) === -1;
      var um = isNew ? null : window.editor.activeUndoManager;

      var change = s.model.get( 'content.html' ) !== this.controls.codeEditor.getValue() ||
        s.model.get( 'name' ) !== this.getName();

      if (!isNew && change) {
        this.startUndoGroup();
      }

      if (change) {
        s.model.set('name', this.getName(), um);
        s.model.set( 'content.html', this.controls.codeEditor.getValue() );
        s.model.set('content.html', this.controls.codeEditor.getValue(), um);
        s.model.set('content.valid', this.controls.codeEditor.isValid(), um);
        s.model.set('content.errors', this.controls.codeEditor.getErrors(), um);
      }

      if (isNew) {
        if (this.validateStylesheet(s)) {
          this.startUndoGroup();
          window.editor.page.insertElement(s);
          this.newStylesheets = [];
          this.updateList();
        } else {
          this.newStylesheets = this.newStylesheets.without(s);
        }
      } else {
        window.editor.page.updateElement(s);
      }
    },

    getName: function(){
      return _.escape(this.controls.stylesheetName.getValue());
    },

    updateView: function() {
      var listItem = this.list.e.down('li#item-'+this.selectedStylesheet.id + ' a');
      var stylesheetTitle = this.getName();
      listItem.update(stylesheetTitle.truncate(25));
      listItem.setAttribute('title', stylesheetTitle);
    },

    requestFocus: function(){
      window.editor.keyController.requestFocus(this);
    },

    startUndoGroup: function() {
      if (this.undoGroupStarted) {
        return;
      }
      this.undoGroupStarted = true;
      window.editor.activeUndoManager.startGroup();
    },

    cancel: function() {
      this.closeIfValid();
    },

    done: function() {
      this.closeIfValid();
    },

    open: function($super,elm, options) {
      $super();
      if (options && options.callback) {
        this.options.callback = options.callback;
      }

      this.requestFocus();
      this._updateHeaderTitle();

      this.newStylesheets = [];
      this.currentStylesheets = [];
      this.selectedStylesheet = null;

      // TODO
      // BUG what is the desired behaviour here. newStylesheet is not used
      var newStylesheet = elm || this.addStylesheet(); // jshint ignore:line

      if (elm) {
        this.updateList(false);
        this.selectStylesheet(elm);
        var model = elm.model;
        var valid =  model.exists('content.valid') ? model.get('content.valid') : true;
        var closeFunction = this.closeIfValid;
        this.controls.codeEditor.showHTMLWarningIfInvalid(this, closeFunction, valid);
      } else {
        this.addStylesheet();
      }
    },

    closeIfValid: function() {
      this.controls.codeEditor.isValidContentHTML(this, this.forceClose);
    },

    forceClose: function(force) {
      if(!!force) {
        this.updateSelectedStylesheet(this);

        if (this.undoGroupStarted) {
          window.editor.activeUndoManager.endGroup();
          this.undoGroupStarted = false;
        }

        this.close();
      }
    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-stylesheet/stylesheet_element_builder.js
// module id = 1476
// module chunks = 0